class BasicAnalysisEventCtrl
  constructor: (@$scope, ScoreCardAPIService, $routeParams) ->
    @basicAnalysisData =
      goal: @$scope.$parent.goalSettings
      my_avg: undefined
      all_members: undefined

    params =
      user_id: $routeParams.user_id
      round_type: '0.5,1,1.5'
    ScoreCardAPIService.getAllMembersByEvent($routeParams.id,params).then (data) =>
      @basicAnalysisData.all_members = data

    @$scope.$on "myAnalysisEventUpdated.gnp.analysis", (event, myAnalysis) =>
      @basicAnalysisData.my_avg = myAnalysis.my_avg

BasicAnalysisEventCtrl.$inject = [
  '$scope'
  'ScoreCardAPIService'
  '$routeParams'
]

module.exports = BasicAnalysisEventCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis-event/basic-analysis/basic-analysis-controller.coffee